<div class="detail-page-summary">
    <div class="row">
        @switch (selectedModule) {
            @case (moduleTypes.ORM) {
                <div class="col-12">
                    <div class="property">
                        <b>{{ "periods.ormIntroTitle" | transloco }}</b>
                    </div>
                    <div class="property" [innerHTML]="'periods.ormIntroBody' | transloco"></div>
                </div>
            }
            @case (moduleTypes.BIM) {
                <div class="col-12">
                    <div class="property">
                        <b>{{ "periods.bimIntroTitle" | transloco }}</b>
                    </div>
                    <div class="property" [innerHTML]="'periods.bimIntroBody' | transloco"></div>
                </div>
            }
        }
    </div>
</div>

@if (configLoaded) {
    <div menuSystem [cerrixTab]="tab" (changeEvent)="tabChanged($event)">
        <div
            [attr.name]="'periods.submenuName' | transloco"
            menuItemId="menuItemPeriods"
            menuicon="fas fa-business-time"
            menusystemsubmenu
        >
            @if (isRiskAdminU) {
                <div
                    [attr.menuItemId]="moduleTypes.ORM"
                    name="ORM"
                    menuicon="fas fa-exclamation-triangle"
                    menusystemitem
                >
                    @if (selectedModule === moduleTypes.ORM) {
                        @if (configLoaded) {
                            <generic-list-manager [config]="config"></generic-list-manager>
                        } @else {
                            <div class="fancy-loader"></div>
                        }
                    }
                </div>
            }
            @if (isBimAdminU) {
                <div
                    [attr.menuItemId]="moduleTypes.BIM"
                    name="BIM"
                    menuicon="fas fa-tasks"
                    menusystemitem
                >
                    @if (selectedModule === moduleTypes.BIM) {
                        @if (configLoaded) {
                            <generic-list-manager [config]="config"></generic-list-manager>
                        } @else {
                            <div class="fancy-loader"></div>
                        }
                    }
                </div>
            }
        </div>
    </div>
}
